import { render, staticRenderFns } from "./v_Player_Play_Item.vue?vue&type=template&id=23cd8c62&scoped=true&"
import script from "./v_Player_Play_Item.vue?vue&type=script&lang=js&"
export * from "./v_Player_Play_Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cd8c62",
  null
  
)

export default component.exports